export function hasFileDragPayload(dataTransfer: { types?: ArrayLike<string> } | null | undefined): boolean {
  return Array.from(dataTransfer?.types ?? []).includes("Files");
}

export function filesFromDrop(dataTransfer: { files?: ArrayLike<File> } | null | undefined): File[] {
  return Array.from(dataTransfer?.files ?? []);
}
